import { createContext } from 'react';

import { QuoteContextState } from './QuoteContextProvider.types';

export const QuoteContext = createContext<QuoteContextState | null>(null);
